import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";

import logger from "../../../../logger";

export const meetingKeys = {
  all: ["meetings"],
  lists: () => [...meetingKeys.all, "list"],
  list: (filters) => [...meetingKeys.lists(), { filters }],
  items: () => [...meetingKeys.all, "item"],
  item: (meetingId) => [...meetingKeys.items(), meetingId],
};

// Queries

export function useMeeting(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: meetingKeys.item(args.meetingId),
    queryFn: () => func(args.meetingId),
    ...queryOptions,
  });
}

export function useMeetings(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: meetingKeys.list(args.filters),
    queryFn: () => func(args.filters),
    ...queryOptions,
  });
}

export function useCreatorMeetings(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: meetingKeys.list(args.filters),
    queryFn: () => func(args.filters),
    ...queryOptions,
  });
}

export function useClassroomDiscussions(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: meetingKeys.list(args.filters),
    queryFn: () => func(args.filters),
    ...queryOptions,
  });
}

// Mutations

export function useCreateMeeting(func) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: meetingKeys.lists() });
    },
  });
}

export function useUpdateMeeting(func) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: meetingKeys.lists() });
    },
  });
}

export function useStartTranscribe(func) {
  // const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
      throw error;
    },
    onSuccess: (data) => {
      // queryClient.invalidateQueries({queryKey:meetingKeys.lists()});
      return data;
    },
  });
}

export function useStopTranscribe(func) {
  // const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
      throw error;
    },
    onSuccess: (data) => {
      // queryClient.invalidateQueries({queryKey:meetingKeys.lists()});
      return data;
    },
  });
}

export function useSaveTranscribe(func) {
  // const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
      throw error;
    },
    onSuccess: (data) => {
      // queryClient.invalidateQueries({queryKey:meetingKeys.lists()});
      return data;
    },
  });
}

export function useScheduleMeeting(func) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
      throw error;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: meetingKeys.lists() });
      return data;
    },
  });
}

export function useDeleteMeeting(func) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
      throw error;
    },
    onSuccess: (variables) => {
      queryClient.invalidateQueries({ queryKey: meetingKeys.lists() });
      queryClient.invalidateQueries({
        queryKey: meetingKeys.item(variables.meetingId),
      });
    },
  });
}

export function useDeleteDiscussion(func) {
  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      logger.error(error);
      throw error;
    },
    onSuccess: () => {},
  });
}

export function useGradeConversation(func) {
  // const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
      throw error;
    },
    onSuccess: (data) => {
      // queryClient.invalidateQueries({queryKey:meetingKeys.lists()});
      return data;
    },
  });
}

export function useBatchGradeConversations(func) {
  // const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (variables) => func(variables),
    onError: (error) => {
      logger.error(error);
      throw error;
    },
    onSuccess: (data) => {
      // queryClient.invalidateQueries({ queryKey: meetingKeys.lists() });
      return data;
    },
  });
}
